import * as angular from 'angular';

import { IRequestService } from '..';
import { TagStringValueDto } from '../../models';

export interface IStringValuesService {
    getAll(): angular.IPromise<TagStringValueDto[]>;
}

export class StringValuesService implements IStringValuesService {
    static serviceId = 'stringValuesService';

    static $inject = [
        'requestService'
    ];

    constructor(
        private _requestService: IRequestService,
    ) {
    }

    private controllerUrl() {
        return `${this._requestService.getUrlV1()}tagStringValues/`;
    }

    getAll(): angular.IPromise<TagStringValueDto[]> {
        const url = this.controllerUrl();
        this._requestService.cleanCache(url);
        return this._requestService.get(url);
    }
}